interface ChatHeaderProps {
  onReset: () => void;
  onClose: () => void;
}

const ChatHeader = ({ onReset, onClose }: ChatHeaderProps) => (
  <div className="flex items-center gap-3 px-4 py-3.5 border-b border-gray-200 bg-white shrink-0">
    {/* Avatar */}
    <div
      className="relative w-10 h-10 rounded-full flex items-center justify-center shrink-0"
      style={{ background: 'linear-gradient(135deg, #317690, #163544)' }}
    >
      <svg width="22" height="22" viewBox="0 0 28 28" fill="none">
        <circle cx="9" cy="8" r="3.2" stroke="white" strokeWidth="1.6" />
        <circle cx="19" cy="8" r="3.2" stroke="white" strokeWidth="1.6" />
        <path
          d="M6 20c0-4.4 3.6-8 8-8s8 3.6 8 8"
          stroke="white"
          strokeWidth="1.6"
          strokeLinecap="round"
        />
        <circle cx="14" cy="18" r="1.4" fill="white" />
      </svg>
    </div>

    {/* Name + status */}
    <div className="flex-1 min-w-0">
      <div className="font-semibold text-[15px] text-gray-700 leading-tight">
        Ask Prowl
      </div>
      <div className="flex items-center gap-1.5 mt-0.5">
        <span className="w-[7px] h-[7px] rounded-full bg-green-500 shrink-0" />
        <span
          className="font-medium text-[11px] tracking-wide"
          style={{ color: 'var(--chat-accent, #317690)' }}
        >
          AI Assistant · Online
        </span>
      </div>
    </div>

    {/* Reset */}
    <button
      onClick={onReset}
      title="Reset conversation"
      className="w-7 h-7 rounded-lg flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors"
      aria-label="Reset conversation"
    >
      <svg
        width="15"
        height="15"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M23 4v6h-6" />
        <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" />
      </svg>
    </button>

    {/* Close */}
    <button
      onClick={onClose}
      className="w-7 h-7 rounded-lg flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors"
      aria-label="Close chat"
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      >
        <path d="M18 6L6 18M6 6l12 12" />
      </svg>
    </button>
  </div>
);

export default ChatHeader;
